import * as React from 'react';
import { CustomThunkDispatch } from 'configureStore';
import { RootState } from 'rootReducer';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { activeAppspaceIdSelector } from './selectors';
import { connect } from 'react-redux';
import { getAcl } from './actions';
import AuthProvider from '@sportnet/auth-react/AuthProvider';
import Authorization from '../../authorization';
import InvitationAuthorization from '../../invitationAuthorization';
import PpoSelector from '@sportnet/auth-react/PpoSelector';
import config from '../../config';
import styled from '../../theme/styled-components';

const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
  min-width: 100vw;
`;

const mapStateToProps = (state: RootState) => ({
  activeAppSpace: activeAppspaceIdSelector(state),
});

type Props = {
  dispatch: CustomThunkDispatch;
} & ReturnType<typeof mapStateToProps>;

const App: React.FC<Props> = ({ dispatch, activeAppSpace }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (activeAppSpace) {
      dispatch(getAcl.action(activeAppSpace));
    }
  }, [activeAppSpace, dispatch]);

  return (
    <Wrapper>
      <AuthProvider app={config.APP_ID}>
        <Routes>
          <Route
            path="/"
            element={
              <div style={{ width: '100%' }}>
                <PpoSelector
                  onSelectAppspace={(appSpace) => {
                    const newActiveAppspace = appSpace.ppo;
                    navigate(`/admin/${newActiveAppspace}/instances`);
                  }}
                />
              </div>
            }
          ></Route>
          <Route path={'/_auth'} />
        </Routes>
        <Routes>
          <Route path="/admin/:appspace/*" element={<Authorization />} />
          <Route
            path="/invitation/:instanceId"
            element={<InvitationAuthorization />}
          />
        </Routes>
      </AuthProvider>
    </Wrapper>
  );
};

export default connect(mapStateToProps)(App);
